import { render } from "./CouponTable.vue?vue&type=template&id=49cdfdc8&scoped=true"
import script from "./CouponTable.vue?vue&type=script&lang=ts"
export * from "./CouponTable.vue?vue&type=script&lang=ts"

import "./CouponTable.vue?vue&type=style&index=0&id=49cdfdc8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-49cdfdc8"

export default script